import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {ButtonStyle} from 'ui-library/buttons/Button';
import HorizontalChipListField from 'ui-library/chips/HorizontalChipListField';
import Modal from 'ui-library/modals/Modal';
import {dispatchRemoveWorklistItems, RefreshOptions} from 'worklists/WorklistActions';

import {WorklistSummaryGraphQL} from '../../graphql-fragments/worklists/__generated/WorklistSummaryGraphQL';

export interface RemoveFromWorklistModalProps {
  worklist: WorklistSummaryGraphQL;
  ids: Array<string>;
  onRequestClose: () => void;
  onRequestSubmit: () => void;
  refreshOptions: RefreshOptions;
}

/**
 * Confirmation modal when removing items from a worklist.
 */
export default function RemoveFromWorklistModal(props: RemoveFromWorklistModalProps): JSX.Element {
  function removeItems(): void {
    dispatchRemoveWorklistItems(props.worklist.id, props.ids, props.refreshOptions);
  }

  return (
    <Modal
      buttons={[
        {
          submit: true,
          text: 'Remove items',
          style: ButtonStyle.NEGATIVE,
        },
      ]}
      onRequestClose={props.onRequestClose}
      onRequestSubmit={() => {
        removeItems();
        props.onRequestSubmit();
      }}
      title={`Remove items from worklist ${props.worklist.name}`}
      titleIcon={ModelTypeConstants.WORKLIST}
      dataTestAttrs={{component: 'RemoveFromWorklistModal', element: 'root'}}
    >
      <HorizontalChipListField ids={props.ids} title="Selected items" />
    </Modal>
  );
}
